import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanies, setSelectedCountry } from "../../features/CompanySlice";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";

const SearchFilter = () => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const selectedCountry = useSelector((state) => state.company.selectedCountry);
  const dispatch = useDispatch();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(".dropdown-container")) {
        setIsOpen(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  // Assuming companies are stored in redux and `companies` is the slice name
  const companies = useSelector((state) => state.company.companies); 
 

  // Extract unique countries from the fetched companies data
  const countries = Array.from(new Set(companies.map((company) => company.country)));
  const handleSearch = () => {
    if (query.length > 0) {
      dispatch(fetchCompanies(query)); // Dispatch action to fetch data with search query
    } else {
      dispatch(fetchCompanies("")); // Refresh all data when search is empty
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleClear = () => {
    if (query !== "") {
      setQuery(""); // Clear the input
      dispatch(fetchCompanies("")); // Trigger search with empty query
    }
  };

  const handleCountryFilter = (country) => {
    console.log("selected country " , country)
    dispatch(setSelectedCountry(country));
    setIsOpen(false);
  };

  return (
    <div className="bg-white shadow rounded-lg p-4">
      <div className="mb-3">
        <h3 className="font-semibold text-gray-900">What are you looking for?</h3>
      </div>
      <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
        <div className="relative w-full min-w-0">
          {/* Search Icon */}
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <MagnifyingGlassIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
          </div>
          {/* Input Field */}
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown} // Handle enter key press
            placeholder="Search with Email, Name, Surname, mobile number or Company Name..."
            className="pl-10 pr-10 p-2 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-[#90c740]"
          />
          {/* Clear (X) Button */}
          {query.length > 0 && (
            <button
              onClick={handleClear}
              className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-red-500"
            >
              <XMarkIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          )}
        </div>
        {/* Search Button */}
        <button
          onClick={handleSearch}
          className="btn-create-customer w-full sm:w-auto"
        >
          Search
        </button>
      </div>
      
        {/* Dropdown for Countries */}
        <div className="mt-4 flex w-full flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
          <label className="text-sm font-bold text-gray-700 whitespace-nowrap">
            Filter by Country
          </label>

          <div className="relative dropdown-container w-full sm:max-w-xs">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex justify-between w-full px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 bg-white rounded-md shadow-sm hover:bg-gray-50 focus:outline-none"
            >
              {selectedCountry || "Select Country"}
              <svg
                className="ml-2 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 6.293a1 1 0 011.414 0L10 9.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {isOpen && (
              <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1">
                  {/* Default "Select Country" option */}
                  <button
                    onClick={() => handleCountryFilter("Select Country")}
                    className="w-full block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Select Country
                  </button>

                  {/* Country options */}
                  {countries.map((country) => (
                    <button
                      key={country}
                      onClick={() => handleCountryFilter(country)}
                      className="w-full block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      {country}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>


    </div>
  );
};

export default SearchFilter;
